
import {defineComponent} from 'vue'
import ItemCity from "@/components/Home/ItemCity.vue";
import axios from "axios";
import {API_BASE_URL, API_KEY} from "@/config";

export default defineComponent({
  name: 'HomePage',
  components: {ItemCity},
  data() {
    return {
      cityInput: '',
      items: [],
      messageError: '',
      showMessageError: false,
    }
  },
  methods: {
    addDateCity() {
      axios.get(`${API_BASE_URL}?q=${this.cityInput}&lang=en&units=metric&appid=${API_KEY}`).then((res) => {
        this.$store.state.dataCity.push({city: this.cityInput})
        this.cityInput = ''
      }).catch((err) => {
        this.messageError = err.response.data.message;
        this.showMessageError = true;
        setTimeout(()=> {
          this.messageError = '';
          this.showMessageError =false;
        }, 3000)
      })
    },
    itemData() {
      return this.items = this.$store.state.dataCity
    }
  },
  created() {
    if (localStorage.getItem('city')) {
      this.$store.state.dataCity = JSON.parse(localStorage.getItem('city')!)
    }
    this.itemData()
  }
})
